import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";

export default observer(function TimePlayedData() {
	const { t } = useTranslation();

	const rootStore = useRootAppStore();

	return (
		<>
			<div className="row u-mar--bottom--xsml">
				<div className="col col-sml-6">
					{t<string>("SESSION.REALITY_CHECK.TIME_PLAYED")}:
				</div>
				<div className="col col-sml-6 u-type--color--primary">
					<strong>
						{t<string>("SESSION.REALITY_CHECK.TIME_PLAYED_VALUE", {
							0: rootStore.realityCheckStore.timePlayedData.hours,
							1: rootStore.realityCheckStore.timePlayedData
								.minutes,
						})}
					</strong>
				</div>
			</div>
		</>
	);
});
